import React from 'react';
import './serviceModal.css';

const ServiceModal = ({ isOpen, onClose, service, scrollToContact }) => {
  if (!isOpen || !service) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <span className="close-icon" onClick={onClose}>&#10005;</span>
        <h2 className="modal-title">{service.name}</h2>
        <p className="modal-desc">
          Professional {service.name.toLowerCase()} with top-grade equipment and eco-friendly methods.
        </p>
        <p style={{color:"hsl(45, 90%, 60%)",fontWeight:"bold"}}> Today's Offer: <span style={{fontWeight:"bold"}}>{service.discount}% off</span> </p>
        <button className="btn" onClick={scrollToContact}>Get Quote</button>
      </div>
    </div>
  );
};

export default ServiceModal;
